import React from 'react';
import PropTypes from 'prop-types';
import { dateToString } from '../../common/utils/date/Date.utils';

function EditDealerChangesTableRow({ item }) {
  const { createdOn, createdBy, changes } = item;

  return (
    <>
      <td>{createdOn && dateToString(createdOn)}</td>
      <td>{createdBy}</td>
      <td>
        {changes?.map(({ id, description }) => (
          <p className="mt-0 mb-0" key={id}>
            {description}
          </p>
        ))}
      </td>
    </>
  );
}

EditDealerChangesTableRow.propTypes = {
  item: PropTypes.object,
};
EditDealerChangesTableRow.defaultProps = {
  item: {},
};

export default EditDealerChangesTableRow;
